module.exports = __webpack_public_path__ + "img/stain_finish_supplies.7244ca6c.webp";